import DeliveryNotesPage from "pages/delivery-notes/DeliveryNotes";
import { canUserPerformAction } from "access-roles/general-functions";
import {
  MANAGER_TOOLS_REQUIRED_ROLES,
  ROLE_MATCH_MODE,
} from "constants/constants";
import { Route } from "react-router-dom";

const routes = {
  key: "DELIVERY_NOTES",
  routes: ({ userScope, roles }) =>
    canUserPerformAction({
      userRoles: roles || [],
      requiredRoles: MANAGER_TOOLS_REQUIRED_ROLES,
      mode: ROLE_MATCH_MODE.OR,
    })
      ? [
          <Route
            path={`${userScope}/delivery-notes/:tab`}
            key={"delivery-notes"}
            element={<DeliveryNotesPage />}
          />,
        ]
      : [],
};

export default routes;
